module.exports = __webpack_public_path__ + "static/pickermenu-de3031d5d1d80af9a1c0e5479c5fe93e.png";